import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CSDataLayerService {

  constructor() { }

  // Global GA click trackiung
  private static readonly CLICKABLE = 'button, a, [role="button"]';
  private static readonly INACTIVE = '[aria-disabled="true"], .disabled, mat-bar-button > .active';

  // Tracking Button Clicks
  trackClick(event: MouseEvent): void {
    const button = (event.target as Element).closest(CSDataLayerService.CLICKABLE);
    if (!button) {
      return;
    }
    const tagged = button.hasAttribute('data-test-id') ? button : button.closest('mat-bar-button[data-test-id]');
    if (!tagged || button.matches(CSDataLayerService.INACTIVE)) {
      return;
    }
    this.trackButtonClick(tagged.getAttribute('data-test-id'), this.getComponentName(tagged));
  }

  // Name of the component the button is present
  private getComponentName(el: Element): string {
    // Angular tags a components elements with _ngcontent-x and the component itself with _nghost-X
    const marker = el.getAttributeNames().find((name) => name.startsWith('_ngcontent-'));
    // replacing to find the exact component name
    const component = marker && el.closest(`[${marker.replace('_ngcontent', '_nghost')}]`);
    if (component) {
      return component.nodeName;
    }
    // finding nearest component name ignoring other material and cdk components
    const isAppComponent = (tag: string) => tag.includes('-') && !/^(MAT|CDK)-/.test(tag);
    let parent = el.parentElement;
    while (parent && !isAppComponent(parent.nodeName)) {
      parent = parent.parentElement;
    }
    return parent?.nodeName ?? '';
  }

  trackButtonClick(buttonId: string, componentName: string): void {
    if (!environment.enableClickEvents) {
      return;
    }
    this.trackEvent("button_click", {
      button_id: buttonId,
      component_name: componentName,
      page_path: typeof window !== 'undefined' ? window.location.pathname : '',
    });
  }
  
    trackEvent(eventName: string, params: Record<string, unknown> = {}): void {
      if (typeof window === "undefined") {
        console.warn("Analytics: window not available");
        return;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: eventName, ...params });
  }

}
